'use client';

import ProxyImage from '@shared/ProxyImage/ProxyImage';
import cn from '@sindresorhus/class-names';
import classNames from '@sindresorhus/class-names';
import {retryPromise} from '@utils/retryPromise';
import Link from 'next/link';
import {lazy, Suspense} from 'react';

import {TVBlockSwiperLazy} from '@web-landing/page_components/landing_page/components/TVBlock/Swiper/TVBlockSwiperLazy';

import {TVBlock as TVBlockType} from '@web-landing/strapi/types';

import {logTmrEvent} from '@web-landing/analytics/helpers/logTmrEvent';

import {EVENTS} from '@web-landing/analytics/events';

import stylesOld from './TVBlock.module.scss';
import stylesRedesign from './TVBlock_redesign.module.scss';

const TVSwiper = lazy(
  retryPromise(
    () =>
      import(/* webpackChunkName: "TVBlockSwiper" */ './Swiper/TVBlockSwiper'),
    {
      fallback: {default: TVBlockSwiperLazy},
    },
  ),
);

export const TVBlock = ({
  title,
  buttonText,
  targetBlankButton,
  tvApps,
  buttonHref,
  backgroundImage,
  subtitle,
  locale,
  redesign,
  catalogLinkText,
}: TVBlockType) => {
  const onClick = () => {
    logTmrEvent(EVENTS.landingClick, {
      button_text: buttonText,
      element_type: 'button',
    });
  };
  const styles = redesign ? stylesRedesign : stylesOld;

  return (
    <section className={styles.section}>
      <div className={styles.wrapper}>
        <h2
          className={classNames(styles.title, {
            [styles.title__redesign]: redesign,
          })}
        >
          {title}
        </h2>
        <ProxyImage
          imageData={backgroundImage}
          className={styles.backgroundImage}
        />
        <Suspense fallback={<TVBlockSwiperLazy tvApps={tvApps} />}>
          <TVSwiper
            tvApps={tvApps}
            catalogLinkText={catalogLinkText}
            redesign={redesign}
            compilationTitle={title}
          />
        </Suspense>

        <div className={styles.footerContent}>
          <span
            className={cn(styles.subtitle, {[styles.chinese]: locale === 'zh'})}
          >
            {subtitle}
          </span>
          <Link
            onClick={onClick}
            href={buttonHref}
            target={targetBlankButton ? '_blank' : '_self'}
            className={styles.button}
          >
            {buttonText}
          </Link>
        </div>
      </div>
    </section>
  );
};
